// Observation — the answer to ONE constraint's predicate for a material,
// the trusted datum fed into the pure evaluation (`./evaluate.ts`).
//
// This is the pure-core line drawn as data. The evaluation algebra is a
// pure fold over Observations; it never itself reaches into a material,
// walks the KB, or calls an LLM. The SHELL (the app-layer workflow)
// produces the Observations — running the computed predicates
// (`./builtins.ts`) over the material's signals, and, later, folding
// judged attestations — then hands them to the core to combine with a
// Policy at a Boundary.
//
// Two shapes only:
//   - `constraint_measured` — a verdict exists: the predicate was
//     answered (satisfied / violated) and a Score was produced. Computed
//     constraints always land here; a judged constraint lands here once
//     its attestation is folded.
//   - `constraint_pending` — a judged constraint with no attestation yet
//     (no verdict, no score). The typed seam: the core records "not yet
//     judged" rather than fabricating a pass or fail.
//
// The `computed | judged` provenance is NOT duplicated here — it lives on
// the `Constraint` (`./constraint.ts`). The algebra derives the bite the
// same way whether a measured verdict was computed or judged; provenance
// is read off the policy member.
//
// Pure module.
export { measured, pending };
const measured = (constraintId, outcome, score) => ({
    type: "constraint_measured",
    constraintId,
    outcome,
    score,
});
const pending = (constraintId) => ({
    type: "constraint_pending",
    constraintId,
});
//# sourceMappingURL=observation.js.map